import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const Confirm = ({
  width = 40,
  height = 40,
  className,
  color,
  decorative = false,
  ariaLabel = "Confirm",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 40 40"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#008055"
        fillRule="evenodd"
        d="M20.695 36.665c-9.588 0-17.361-7.462-17.361-16.666S11.107 3.332 20.695 3.332c4.605 0 9.02 1.756 12.276 4.882s5.085 7.364 5.085 11.785c0 9.204-7.773 16.666-17.36 16.666m8.854-23.5 1.216 1.167-13.542 12.667-8.16-7.667 1.215-1.167 6.945 6.5zM20.695 5c8.63 0 15.625 6.715 15.625 15s-6.995 15-15.625 15-15.625-6.716-15.625-15c0-8.285 6.996-15 15.625-15"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

